exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ConversionStep img {\n  width: 100%;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/components/ConversionStep/ConversionStep.css
 ** module id = 421
 ** module chunks = 0
 **/